export const creatingArray = (length: number): number[] => Array.from({ length }, (_, i) => i);